module.exports = __webpack_public_path__ + "img/8.5be11fa5.png";